import { render } from "./TownSelect.vue?vue&type=template&id=566c18ec&scoped=true"
import script from "./TownSelect.vue?vue&type=script&lang=js"
export * from "./TownSelect.vue?vue&type=script&lang=js"

import "./TownSelect.vue?vue&type=style&index=0&id=566c18ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566c18ec"]])

export default __exports__